import { GenieInsights } from "@/components/agent/details/GenieInsights";
import { CoreDrawer } from "@/components/common/CoreDrawer";
import { Agent } from "@/types/agent/agent";

interface GenieInsightsDrawerProps {
  genie: Agent;
  isOpen: boolean;
  onClose: () => void;
}

export default function GenieInsightsDrawer({ genie, isOpen, onClose }: GenieInsightsDrawerProps) {
  return (
    <CoreDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Genie Insights"
      description="Insights define what gets analysed and extracted after each conversation. Attach an existing insight or create a new one—its fields will be populated automatically once a call or chat ends and saved with each lead."
    >
      <GenieInsights agent={genie} />
    </CoreDrawer>
  );
}
